import { Headline } from '@vkontakte/vkui';
import React, { memo } from 'react';
import { aiImageGenerationStyles } from 'reactApp/appHelpers/featuresHelpers/features/aiImageGeneration';
import type { AiGenerateImageStyleType } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';

import styles from './AiGenerationStylesPopup.css';

interface IProps {
    onClick: (style: AiGenerateImageStyleType) => void;
}

export const AiImageStylesGrid = memo<IProps>(({ onClick }) => {
    return (
        <div className={styles.grid}>
            {aiImageGenerationStyles.map((style) => (
                <div key={style.key} className={styles.card} onClick={() => onClick(style.key)}>
                    <img src={style.image_url} alt={style.name} className={styles.image} draggable={false} />
                    <div className={styles.overlay} />
                    <Headline weight="2" className={styles.headline}>
                        {style.name}
                    </Headline>
                </div>
            ))}
        </div>
    );
});

AiImageStylesGrid.displayName = 'AiImageStylesGrid';
